import { useMemo, useState } from 'react';
import debounce from 'lodash/debounce';

import { DEBOUNCE_TIME } from '../constants/queryParams';

import { useRiderSearchQuery } from './useRiderDetailsSearchQuery';

export interface RiderOption {
  group: string;
  label: string;
  value: number;
  slug: string;
  profilePictureUrl?: string;
}

interface IUseRiderGroupedOptions {
  debouncedHandleQuerySearch: (query: string) => void;
  ridersOnRideOptions: RiderOption[];
  accountRiderOptions: RiderOption[];
  isFetching: boolean;
}

export const useRiderGroupedOptions = ({ ridersOnRide, accountId }): IUseRiderGroupedOptions => {
  const [query, setQuery] = useState<string>();
  const { data: accountRidersDetailsResult, isFetching: isFetchingAccountRidersDetails } = useRiderSearchQuery({
    accountId: accountId,
    q: query || '',
  });

  const ridersOnRideOptions =
    ridersOnRide?.map((rider) => ({
      group: 'Riders on this Ride:',
      label: `${rider.firstName} ${rider.lastName}`,
      value: rider.id,
      slug: rider.slug,
      profilePictureUrl: rider.profilePictureUrl,
    })) || [];

  const filteredAccountRiderOptions =
    accountRidersDetailsResult?.data.filter((rider) => {
      return !ridersOnRide?.some((rideRider) => rideRider.id === rider.id);
    }) || [];

  const accountRiderOptions =
    filteredAccountRiderOptions.map((rider) => ({
      group: 'Riders from Account:',
      label: `${rider.firstName} ${rider.lastName}`,
      value: rider.id,
      slug: rider.slug,
      profilePictureUrl: rider.profilePictureUrl,
    })) || [];

  const isFetching = isFetchingAccountRidersDetails;

  const debouncedHandleQuerySearch = useMemo(() => debounce(setQuery, DEBOUNCE_TIME), []);

  return {
    debouncedHandleQuerySearch,
    ridersOnRideOptions,
    accountRiderOptions,
    isFetching,
  };
};
